import React from 'react';
import Icon from '../../../components/AppIcon';

const GenderSelectionCard = ({ 
  gender, 
  title, 
  price, 
  features, 
  isSelected, 
  onClick 
}) => {
  const getGradient = () => {
    return gender === 'female' ?'from-primary to-secondary' :'from-secondary to-accent';
  };

  const getIconName = () => {
    return gender === 'female' ? 'Heart' : 'Crown';
  };

  return (
    <button
      onClick={onClick}
      className={`relative w-full p-6 rounded-xl transition-smooth border-2 ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-warm-lg'
          : 'border-border bg-card hover:border-primary/50 hover:shadow-warm'
      }`}
    >
      <div className={`absolute top-4 right-4 w-6 h-6 rounded-full border-2 transition-smooth ${
        isSelected
          ? 'border-primary bg-primary' :'border-border bg-transparent'
      }`}>
        {isSelected && (
          <Icon name="Check" size={16} color="#FFFFFF" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
        )}
      </div>
      <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${getGradient()} flex items-center justify-center mb-4`}>
        <Icon name={getIconName()} size={32} color="#FFFFFF" />
      </div>
      <h3 className="text-xl font-heading font-semibold mb-2">{title}</h3>
      <div className="mb-4">
        <span className={`text-2xl font-bold ${gender === 'female' ? 'text-success' : 'text-primary'}`}>
          {price}
        </span>
        {gender === 'male' && (
          <span className="text-sm text-muted-foreground ml-1">/month</span>
        )}
      </div>
      <ul className="space-y-2 text-left">
        {features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-2 text-sm">
            <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <span className="text-muted-foreground">{feature}</span>
          </li>
        ))}
      </ul>
    </button>
  );
};

export default GenderSelectionCard;